// eslint-disable-next-line import/prefer-default-export
export const PLUGIN_NAME = 'VideoMediaCenter'
